import React, { Component, Fragment } from 'react';
import { Navbar } from 'components';
import { isIOS, isMobile } from 'react-device-detect';
import classNames from 'classnames';
import './layoutWithBannerNavbarFooter.scss';

class LayoutWithBannerNavbarFooter extends Component {
  state = {
    blueNav: false,
  };

  componentDidMount() {
    this.body.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    this.body.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const { scrollTop } = this.body;
    this.setState({
      blueNav: scrollTop > 0,
    });
  };

  render() {
    const {
      title, background, leftButton, rightButton, onLeftClick, onRightClick, children, className, isRtl, bannerText, noTranslate,
      footerChildren,
    } = this.props;
    const navbarClass = classNames({
      'navbar--scroll': this.state.blueNav,
    });
    const pageClasses = classNames({
      'nw-page': true,
      'nw-page--withFooter': true,
      'nw-page--withBannerNavbar': background,
      'nw-page--withoutBanner': !background,
      'nw-page--ios': isMobile && isIOS,
    });

    return (
      <div className={`${pageClasses} ${className}`}>
        <Navbar
          navTitle={title}
          noTranslate={noTranslate}
          leftButton={leftButton}
          rightButton={rightButton}
          onLeftClick={onLeftClick}
          onRightClick={onRightClick}
          isRtl={isRtl}
          className={navbarClass}
        />

        <div className="nw-page__body" ref={e => this.body = e} id="page-body">
          { background && <div className="nw-banner" style={{ backgroundImage: `url(${background})` }}>{bannerText}</div> }
          <Fragment>{children}</Fragment>
        </div>

        {footerChildren && (
        <footer className="nw-page__footer">
          {footerChildren}
        </footer>
        )}
      </div>
    );
  }
}

export default LayoutWithBannerNavbarFooter;
